import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createSlots as _createSlots } from "vue"

const _hoisted_1 = { class: "inline-flex" }
const _hoisted_2 = { class: "space-y-6 px-4" }
const _hoisted_3 = { class: "grid grid-cols-2 gap-6" }
const _hoisted_4 = /*#__PURE__*/_createVNode("hr", null, null, -1)
const _hoisted_5 = { class: "px-4 pb-4" }
const _hoisted_6 = { class: "flex flex-row items-center mb-3" }
const _hoisted_7 = { class: "w-1/5 whitespace-nowrap mr-4" }
const _hoisted_8 = { class: "w-1/5 whitespace-nowrap" }
const _hoisted_9 = { class: "overflow-auto h-full relative" }
const _hoisted_10 = { class: "space-y-2 pt-2" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "text-12px font-normal text-gray-lp-500 max-w-md" }, " Anda bisa mengaktifkan status ini kapan saja ", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LpButton = _resolveComponent("LpButton")!
  const _component_Title = _resolveComponent("Title")!
  const _component_DataWrapper = _resolveComponent("DataWrapper")!
  const _component_LpInput = _resolveComponent("LpInput")!
  const _component_Search = _resolveComponent("Search")!
  const _component_CustomDropdown = _resolveComponent("CustomDropdown")!
  const _component_ReasonPopover = _resolveComponent("ReasonPopover")!
  const _component_TableV2 = _resolveComponent("TableV2")!
  const _component_Toggle = _resolveComponent("Toggle")!
  const _component_DetailLayout = _resolveComponent("DetailLayout")!

  return (_openBlock(), _createBlock(_component_DetailLayout, {
    onBack: _ctx.goBack,
    title: _ctx.detailData.dbtcId,
    "custom-class": "px-0",
    loading: _ctx.detailEntities.loading,
    error: !!_ctx.detailEntities.message || !!_ctx.userData.isError,
    errorType: _ctx.detailEntities.message || _ctx.userData.message,
    onTryAgain: _ctx.fetchDetail,
    subData: _ctx.subData,
    "leave-page-confirmation": _ctx.leavePageConfirmation,
    "onUpdate:leave-page-confirmation": _cache[6] || (_cache[6] = ($event: any) => (_ctx.leavePageConfirmation = $event)),
    onLeavePage: _ctx.onLeavePage
  }, _createSlots({
    data: _withCtx(() => [
      _createVNode("div", _hoisted_2, [
        _createVNode(_component_Title, { label: "Detail Informasi Konfigurasi" }),
        _createVNode("div", _hoisted_3, [
          _createVNode(_component_DataWrapper, {
            label: "ID",
            value: _ctx.detailData.dbtcId
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            label: "Nama Konfigurasi",
            value: _ctx.detailData.dbtcName
          }, null, 8, ["value"]),
          _createVNode(_component_DataWrapper, {
            label: "Deskripsi Konfigurasi",
            value: _ctx.detailData.dbtcDescription,
            class: "col-span-2",
            asterisk: _ctx.isEdit
          }, {
            default: _withCtx(() => [
              (_ctx.isEdit)
                ? (_openBlock(), _createBlock(_component_LpInput, {
                    key: 0,
                    modelValue: _ctx.detailData.dbtcDescription,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.detailData.dbtcDescription = $event)),
                    placeholder: "Masukan deskripsi konfiguasi"
                  }, null, 8, ["modelValue"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["value", "asterisk"])
        ]),
        _hoisted_4,
        _createVNode(_component_Title, { label: "Daftar Akun" })
      ]),
      _createVNode("div", _hoisted_5, [
        _createVNode("div", _hoisted_6, [
          _createVNode(_component_Search, {
            onInput: _ctx.onSearch,
            onClear: _ctx.onSearch,
            value: _ctx.userRequest.search,
            placeholder: "Cari Username atau No. Hp",
            class: "w-1/4"
          }, null, 8, ["onInput", "onClear", "value"]),
          _createVNode("div", _hoisted_7, [
            _createVNode(_component_CustomDropdown, {
              selectedItem: _ctx.userRequest.status,
              "onUpdate:selectedItem": _cache[2] || (_cache[2] = ($event: any) => (_ctx.userRequest.status = $event)),
              options: _ctx.statusData,
              placeholder: "Pilih Status",
              onSelect: _ctx.onFilter
            }, null, 8, ["selectedItem", "options", "onSelect"])
          ]),
          _createVNode("div", _hoisted_8, [
            _createVNode(_component_CustomDropdown, {
              selectedItem: _ctx.userRequest.role,
              "onUpdate:selectedItem": _cache[3] || (_cache[3] = ($event: any) => (_ctx.userRequest.role = $event)),
              options: _ctx.roleData,
              placeholder: "Pilih Role",
              onSelect: _ctx.onFilter
            }, null, 8, ["selectedItem", "options", "onSelect"])
          ])
        ]),
        _createVNode("div", _hoisted_9, [
          _createVNode(_component_TableV2, {
            loading: _ctx.userData.loading,
            borderTop: false,
            borderBottom: false,
            columns: _ctx.columns,
            data: _ctx.detailData.userList,
            isEmpty: _ctx.isEmpty,
            emptyHeaderMessage: "Tidak Ada Daftar Akun",
            emptyMessage: "Mulai buat Daftar Akun dan cek daftarnya disini",
            class: "my-2",
            pagination: _ctx.userRequest.pagination,
            "onUpdate:pagination": _cache[4] || (_cache[4] = ($event: any) => (_ctx.userRequest.pagination = $event)),
            onRequest: _ctx.fetchUserList,
            onTryAgain: _ctx.fetchUserList,
            paginationStyle: "v3"
          }, {
            "alasan-tiket-dex": _withCtx(({ item }) => [
              _createVNode(_component_ReasonPopover, {
                item: item,
                columnName: 'Alasan Tiket DEX',
                dexReasons: _ctx.dexReasons,
                getDexReasonCodes: _ctx.getDexReasonCodes,
                getAllReasonNames: _ctx.getAllReasonNames
              }, null, 8, ["item", "dexReasons", "getDexReasonCodes", "getAllReasonNames"])
            ]),
            "alasan-tiket-sanggah": _withCtx(({ item }) => [
              _createVNode(_component_ReasonPopover, {
                item: item,
                columnName: 'Alasan Tiket Sanggah',
                disputeReasons: _ctx.disputeReasons,
                getDisputeReasonCodes: _ctx.getDisputeReasonCodes,
                getAllReasonNames: _ctx.getAllReasonNames
              }, null, 8, ["item", "disputeReasons", "getDisputeReasonCodes", "getAllReasonNames"])
            ]),
            "3lc-dex": _withCtx(({ item }) => [
              _createVNode(_component_ReasonPopover, {
                item: item,
                columnName: '3LC Ditugaskan',
                threeLcCodesOptions: _ctx.threeLcCodesOptions,
                getAllReasonNames: _ctx.getAllReasonNames
              }, null, 8, ["item", "threeLcCodesOptions", "getAllReasonNames"])
            ]),
            _: 1
          }, 8, ["loading", "columns", "data", "isEmpty", "pagination", "onRequest", "onTryAgain"])
        ]),
        (_ctx.isEdit)
          ? (_openBlock(), _createBlock(_component_DataWrapper, {
              key: 0,
              label: "Status Konfigurasi Kuota Tiket CS",
              class: "col-span-2 mt-8"
            }, {
              default: _withCtx(() => [
                _createVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createVNode(_component_Toggle, {
                    "onUpdate:modelValue": [
                      _ctx.onClickToggleStatus,
                      _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailData.dbtcStatusData = $event))
                    ],
                    modelValue: _ctx.detailData.dbtcStatusData,
                    textActive: "Aktif",
                    textInactive: "Tidak Aktif"
                  }, null, 8, ["onUpdate:modelValue", "modelValue"])
                ])
              ]),
              _: 1
            }))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 2
  }, [
    (_ctx.isEdit)
      ? {
          name: "top-right",
          fn: _withCtx(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode(_component_LpButton, {
                "text-color": "white",
                customClass: "w-full py-2.5",
                title: "Simpan",
                onClick: _ctx.onSave,
                disabled: _ctx.isDisableSave
              }, null, 8, ["onClick", "disabled"])
            ])
          ])
        }
      : undefined
  ]), 1032, ["onBack", "title", "loading", "error", "errorType", "onTryAgain", "subData", "leave-page-confirmation", "onLeavePage"]))
}